import { Component } from 'react';

/**
 * Last line of defence: a render error shows a readable message instead of a
 * blank black page — which on this product is indistinguishable from a working
 * one, since the working one is also black.
 *
 * Copy is passed IN rather than translated here, because the boundary sits above
 * the locale provider: if the provider is what threw, there is no `t()` to call.
 */
export default class AppErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        console.error('Unhandled render error:', error, errorInfo);
    }

    render() {
        const { children, title, body } = this.props;

        if (!this.state.hasError) {
            return children;
        }

        return (
            <div className="app-error" role="alert">
                <h1 className="app-error__title">{title}</h1>
                <p className="app-error__body">{body}</p>
            </div>
        );
    }
}
